// @flow

export const getRowHeightByValue = (valueLength: number, rowHeight: number): number => {

    switch (valueLength) {
        case 0: return rowHeight;
        case 1: return rowHeight;
        case 2:
        case 3: return rowHeight * valueLength - valueLength;
        default: return rowHeight * 4 - 6;
    }
};
